export const environment = {
  production: true,

  appUrl: 'https://diwantakeaway.expertapps.com.sa',
  apiUrl: 'https://diwantakeawayapi.expertapps.com.sa/api',
  signalR: 'https://diwantakeawayslr.expertapps.com.sa/hubs',

  googleSiteKey: '6Lfm3xohAAAAALgLSfUIY8YHdzC16AjLY6wl7U9a',
  googleApiKey: '6Lfm3xohAAAAADEauzDDPzU0YVrIxWTBbi1k3AkE',
};
